var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.07273C1 5.07273 2.77386 1 8 1C13.2261 1 15 5.07273 15 5.07273C15 5.07273 13.2261 9.14545 8 9.14545C2.77386 9.14545 1 5.07273 1 5.07273Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0727 5.07273C12.0727 7.32386 10.2511 9.14545 7.99997 9.14545C5.74884 9.14545 3.92725 7.32386 3.92725 5.07273C3.92725 2.82159 5.74884 1 7.99997 1C10.2511 1 12.0727 2.82159 12.0727 5.07273Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52732 5.07271C9.52732 5.9159 8.84323 6.59999 8.00005 6.59999C7.15687 6.59999 6.47278 5.9159 6.47278 5.07271C6.47278 4.22953 7.15687 3.54544 8.00005 3.54544C8.84323 3.54544 9.52732 4.22953 9.52732 5.07271Z",
    fill: "#00A3FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.8a55b2d1b8e28d87a0a47a56a4e6432c.svg";
export { ForwardRef as ReactComponent };